/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { OrderStatusType } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserNotificationOrderStatusChangeRequest';
import { OrderStatus } from 'domains/order/Order.types';
import {
  getUserNotificationSettings,
  updateUserNotificationOrderStatusChangeRequestSaga,
  updateUserNotificationSettingsRequestSaga,
} from 'domains/user';
import {
  NotificationCheckbox,
  NotificationCheckboxProps,
} from 'pages/SettingsPage/NotificationCenter/NotificationUtils/NotificationCheckbox';
import { NotificationSwitch } from 'pages/SettingsPage/NotificationCenter/NotificationUtils/NotificationSwitch';
import { SDivider, SectionWrapper } from 'pages/SettingsPage/ProfilePage.styled';
import { Flex } from 'UI';

export const OrdersCard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const notificationSettings = useSelector(getUserNotificationSettings);

  const handleSwitchOrderStatusChange = (enabled: boolean) => {
    dispatch(updateUserNotificationSettingsRequestSaga({ notificationType: 'ORDER_STATUS_CHANGE', enabled }));
  };

  const isSelectedOrderStatus = (orderStatus: OrderStatusType) =>
    notificationSettings?.orderStatusChangeNotificationTypes?.find((x) => x.notificationOrderStatusType === orderStatus)
      ?.enabled ?? false;

  const selectOrderStatus = (enabled: boolean, orderStatus: OrderStatusType) => {
    dispatch(updateUserNotificationOrderStatusChangeRequestSaga({ orderStatus, enabled }));
  };

  const orderNotificationEnabled =
    notificationSettings?.notificationTypes?.find(
      (notificationType) => notificationType.notificationType === 'ORDER_STATUS_CHANGE',
    )?.enabled ?? false;

  const notificationCheckboxData: NotificationCheckboxProps[] = [
    {
      key: OrderStatus.CANCELLED,
      label: t('settings.notification_center.status_change_cancelled', 'Cancelled'),
      checked: isSelectedOrderStatus(OrderStatus.CANCELLED),
      onChange: (enabled) => selectOrderStatus(enabled, OrderStatus.CANCELLED),
      disabled: !orderNotificationEnabled,
    },
    {
      key: OrderStatus.PARTIALLY_DELIVERED,
      label: t('settings.notification_center.status_change_partially_delivered', 'Partially delivered'),
      checked: isSelectedOrderStatus(OrderStatus.PARTIALLY_DELIVERED),
      onChange: (enabled) => selectOrderStatus(enabled, OrderStatus.PARTIALLY_DELIVERED),
      disabled: !orderNotificationEnabled,
    },
    {
      key: OrderStatus.TECHNICAL_ERROR,
      label: t('settings.notification_center.status_change_error', 'Technical error'),
      checked: isSelectedOrderStatus(OrderStatus.TECHNICAL_ERROR),
      onChange: (enabled) => selectOrderStatus(enabled, OrderStatus.TECHNICAL_ERROR),
      disabled: !orderNotificationEnabled,
    },
  ];

  return (
    <SectionWrapper>
      <Flex direction={'column'} gap={15}>
        <NotificationSwitch
          title={t('settings.notification_center.orders', 'Orders')}
          label={t('settings.notification_center.order_notify_receive', 'Receive notifications  ...')}
          isEnabled={orderNotificationEnabled}
          onChange={handleSwitchOrderStatusChange}
          data-cy={'toggle-notification-estimate-section'}
        />
        <SDivider />
        <NotificationSwitch
          label={t('settings.notification_center.order_notify_status', 'When my orders status changes')}
          isEnabled={orderNotificationEnabled}
          onChange={handleSwitchOrderStatusChange}
          data-cy={'toggle-notification-estimate'}
        />
        <Flex direction={'column'} gap={10}>
          {notificationCheckboxData.map((data) => (
            // eslint-disable-next-line
            <NotificationCheckbox {...data} />
          ))}
        </Flex>
      </Flex>
    </SectionWrapper>
  );
};
